import axios, { CancelTokenSource } from 'axios';
import React from 'react';
import { connect } from 'react-redux';

import { IApplicationState } from '../../store/applicationState';
import { fetchGroupMembers } from '../../store/group/groupActions';
import { IGroupMember } from '../../store/group/groupState';
import { deleteGroupResponsible } from '../../services/group';

import Contact from '../../components/shared/contact/Contact';
import Icon from '../../components/shared/icon/Icon';
import LinkButton from '../../components/forms/linkButton/LinkButton';
import Modal from '../../components/shared/modal/Modal';

interface IOwnState {
    showDelete: boolean;
    isDeleting: boolean;
}

interface OwnProps {
    groupId: string;
    member: IGroupMember;
}

interface IStateProps {
    viewerIsDi: boolean;
    canEditResponsible: boolean;
}

interface IDispatchProps {
    fetchGroupMembers: typeof fetchGroupMembers;
}

type Props = OwnProps & IStateProps & IDispatchProps;

class Members extends React.Component<Props, IOwnState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            showDelete: false,
            isDeleting: false,
        };
    }

    public render() {
        return <React.Fragment>
            <div className="practical__contact">
                <Contact member={this.props.member} modifierClass="contact--practical" useRoundedImage={true} useRoleTitle={true} />
                {this.props.viewerIsDi && this.props.canEditResponsible &&
                    <a href="/#" className="button button--action has-icon pointer" onClick={this.toggleDelete}>
                        <span className="text">
                            <span className="icon icon--right-spacing">
                                <Icon name="trash" />
                            </span>
                            Slet ansvarlig
                        </span>
                    </a>
                }
            </div>

            <Modal show={this.state.showDelete} onClose={this.toggleDelete}>
                <div className="rich-text">
                    <h3>Slet ansvarlig?</h3>
                    <p>Vil du fjerne {this.props.member.fullName} som ansvarlig for gruppen?</p>
                </div>

                <div className="modal__content__form__actions modal__content__form__actions--border">
                    <div className="flex-grid">
                        <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-12 flex-grid__col--lg-12 align-right form__section__inner">
                            <LinkButton modifierClass="button--discreet button--light" disabled={this.state.isDeleting} onClick={this.toggleDelete}>Annuller</LinkButton>
                            <LinkButton modifierClass="button--primary button--primary button--large" spinning={this.state.isDeleting} onClick={this.delete}>Slet</LinkButton>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>;
    }

    private toggleDelete = (e: React.FormEvent<HTMLElement> | React.MouseEvent<HTMLElement> | KeyboardEvent) => {
        e.preventDefault();

        this.setState(prevState => ({
            showDelete: !prevState.showDelete
        }));
    }

    private delete = async (e: React.FormEvent<HTMLAnchorElement> | React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        if (!this.state.isDeleting) {
            this.setState({
                isDeleting: true
            });

            // TODO - VALIDATE
            await deleteGroupResponsible(this.props.groupId, { personId: this.props.member.diNumber });

            this.props.fetchGroupMembers(this.props.groupId);

            this.setState({
                isDeleting: false,
                showDelete: false
            });
        }
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
    viewerIsDi: state.oidc.user && state.oidc.user.profile ? state.oidc.user.profile.role === 'DI' : false,
    canEditResponsible: state.groupData.currentGroup && state.groupData.groups.groups.byId[state.groupData.currentGroup] ? state.groupData.groups.groups.byId[state.groupData.currentGroup].canEditResponsible : false
});

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    fetchGroupMembers: (groupId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(fetchGroupMembers(groupId, cancelToken))
});

const container = connect(mapStateToProps, mapDispatchToProps)(Members);

export default container;